import type { AppRuntimeData } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
import type { IComponent, ComponentType } from './types';

/**
 * Represents a facade for GetAppsRuntimeDataResponse type on the apps-runtime-reader service.
 *
 * @class AppRuntimeComponents
 */
export class AppRuntimeComponents {
  constructor(private readonly appRuntimeData: AppRuntimeData | undefined) {}

  get id(): string {
    return this.appRuntimeData?.appId ?? '';
  }

  get components(): IComponent[] {
    return (
      this.appRuntimeData?.components?.map((component) => ({
        compType: component.type as ComponentType,
      })) ?? []
    );
  }
}
